(function(){
    'use strict';

    angular
        .module('elogbooks.admin.settings')
        .controller('AdminEmailEditSettingsController', AdminEmailEditSettingsController);

    function AdminEmailEditSettingsController(
        $controller,
        $state,
        messenger,
        moment,
        lodash,
        apiClient,
        settingsCollection,
        elbSettings,
        module,
        fileTypeService
    ) {
        const vm = this;
        const base = $controller('AdminEditSettingsController', {
            $state: $state,
            messenger: messenger,
            moment: moment,
            lodash: lodash,
            apiClient: apiClient,
            settingsCollection: settingsCollection,
            settingsFields: [
                'email_html_signature',
                'email_text_signature',
                'email_tenant_logo'
            ],
            elbSettings: elbSettings,
            module: module,
            fileTypeService: fileTypeService,
            validateTabSettings: null,
            buildTabSettingFormTypes: () => ({
                'email_html_signature': { type: 'cke-editor', rows: 5 },
                'email_text_signature': { type: 'textarea', rows: 5 },
                'email_tenant_logo': { type: 'image-file-property', subLabel: 'EMAIL_LOGO_SUGGESTED_SIZE' }
            })
        });
        angular.extend(vm, base);
    }
})();
